export default __webpack_public_path__ + "static/media/Deepwound.90a92284.jpg";